import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate, useParams, Navigate, useLocation, } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import GeneratePDF from "../components/GeneratePDF";
import InStockToggle from "../components/InStockToggle";
import RingPopup from "../components/Ringsizepopup";
import { useCurrency } from "../context/CurrencyContext";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { API_BASE_URL, Image_URL, Web_Image_URL } from "../config";
import axios from "axios";
import Currency from "../components/Currency";
import RequestforpriceForm from "../components/Requetforprice";


const PopupNextArrow = ({ onClick }) => {
  return (
    <div className="popup-next-arrow" onClick={onClick}>
      →
    </div>
  );
};

const PopupPrevArrow = ({ onClick }) => {
  return (
    <div className="popup-prev-arrow" onClick={onClick}>
      ←
    </div>
  );
};
const InsideProduct = () => {
  const { id } = useParams(); // ✅ Now inside the component
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // 💰 Markup-related state
  const [finalPrice, setFinalPrice] = useState(0);

  const metalFromURL = queryParams.get("metal");
  const shapeFromURL = queryParams.get("shape");
  const diamondFromURL = queryParams.get("diamond");
  const navigate = useNavigate();
  const { selectedCurrency } = useCurrency();
  const [product, setProduct] = useState(null);
  const [checkboxes, setCheckboxes] = useState([]);
  const [relatedData, setRelatedData] = useState([]);
  const [imagesData, setImagesData] = useState([]);
  const [loadingImages, setLoadingImages] = useState(false);
  const [selectedMetal, setSelectedMetal] = useState({ key: "", name: "" });
  const [selectedShape, setSelectedShape] = useState("");
  const [selectedBandWidth, setSelectedBandWidth] = useState("");
  const [DefaultProductimages, setDefaultProductimage] = useState("");
  const [sizes, setSizes] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("sizeAU"); // Default to AU
  const [selectedSize, setSelectedSize] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // State for selected stone, initially empty
  const [selectedStone, setSelectedStone] = useState("");
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [contentId, setContentId] = useState(null);
  const [productcaratData, setProductCaratData] = useState([]);
  const [ProductCaratCodeData, setProductCaratCodeData] = useState([]);
  const [caratforimg, setCaratForImg] = useState("");

  // 🔑 NEW: remembers the *carat/size value* the user last picked (or that
  // came in from a shared URL), independent of ProductCode/Shape, so it can
  // be re-matched whenever the shape/stone changes and a new carat list loads.
  const [selectedCaratValue, setSelectedCaratValue] = useState(null);

  const [loading, setLoading] = useState(true);

  const [pricedata, setPricedata] = useState(null);

  const [pareValue, setPareValue] = useState("");
  const [allClarities, setAllClarities] = useState([]);
  const [allColours, setAllColours] = useState([]);
  const [allCertificates, setAllCertificates] = useState([]);
  const [wishlistPending, setWishlistPending] = useState(false);
  const metalOrder = [
    "White Gold",
    "Yellow Gold",
    "Rose Gold",
    "Platinum",
    "Silver",
    "Platinum(950)",
    "PLATINUM 625",
    "Silver(925)",
  ];

  //const metalOrder = ["White Gold", "Yellow Gold", "Rose Gold", "Platinum", "Silver"];

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const slider1 = useRef(null);
  const slider2 = useRef(null);
  const [selectedValues, setSelectedValues] = useState({
    Clarity: "",
    Colour: "",
    Certificate: "",
    Cutgrade: "",
    Polish: "",
    Symmetry: "",
    Fluo: "",
    Carat: "",
    ProductCodes: "",
  });

  // 🧭 Track current view mode and force rerender counter
  const [activeView, setActiveView] = useState(
    localStorage.getItem("activeView") || "wholesale"
  );
  const [viewVersion, setViewVersion] = useState(0);
  const [wishlist, setWishlist] = useState([]);

  const [productStockData, setProductStockData] = useState([]);
  const [apiSizes, setApiSizes] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [apiMetalWeight, setApiMetalWeight] = useState(0);
  const [metalVersion, setMetalVersion] = useState(0);
  const [isImagePopupOpen, setIsImagePopupOpen] = useState(false);
  // 🔄 Sync when user switches My/Seller
  const formatCarat = (value) => {
    const num = Number(value);

    if (isNaN(num)) return "";

    // Rule 1: very small values
    if (num > 0 && num < 0.01) {
      return num.toFixed(3);
    }

    // Rule 2: force 0.99 → 1.00
    if (num >= 0.99 && num < 1) {
      return "1.00";
    }

    // Rule 3: normal formatting
    return num.toFixed(2);
  };

  // 🔑 NEW: Given a ProductCaratCodeData item, return the exact display value
  // used to represent its "carat" (or MM size, for colour-stone products).
  // Centralised so every place that needs to compare/remember a carat uses
  // the exact same rule.
  const getItemCaratValue = (item) => {
    if (!item) return "";
    return product?.stoneTag?.includes("Colour Stone MM Size")
      ? item.sizeMM
      : formatCarat(
          product?.stoneTag === "Center Stone" ? item.DefaultCarat : item.Carat
        );
  };

  // 🚩 Guards against the "write state -> URL" effect firing (and wiping the
  // shared query params) before the "read URL -> state" effect has had a
  // chance to hydrate selectedMetal/selectedShape/selectedStone from the URL.
  const initializedFromUrlRef = useRef(false);

  // 🔑 Tracks which URL `productCode` value we've already attempted to
  // apply. Without this, the URL-hydration effect below re-consumes
  // location.search every time ProductCaratCodeData changes (i.e. on every
  // shape/stone switch) — and since it can read a URL value that is one
  // render behind the "write state -> URL" effect, it was stomping a
  // correctly re-matched carat with a stale ProductCode from the previous
  // shape, causing nothing to appear selected after switching shapes.
  const urlProductCodeAppliedRef = useRef(null);

useEffect(() => {
  // Don't touch the URL until we've attempted the initial hydration from it.
  // Otherwise, on first load, empty initial state gets written back to the
  // URL (clearing metal/shape/diamond/productCode) before the product data
  // fetch even resolves.
  if (!initializedFromUrlRef.current) return;

  const params = new URLSearchParams();
  if (selectedMetal?.name) params.set("metal", selectedMetal.name);
  if (selectedShape) params.set("shape", selectedShape);
  if (selectedStone) params.set("diamond", selectedStone);
  if (selectedValues?.ProductCodes) params.set("productCode", selectedValues.ProductCodes);
  if (product?.productCode) params.set("designNumber", product.productCode);

  // 💎 1. Find the active item from data based on chosen ProductCode
  const currentActiveCaratItem = ProductCaratCodeData?.find(
    (item) => item.ProductCode === selectedValues?.ProductCodes
  );

  // 💎 2. Compute the exact carat/MM text value just like you show in your UI
  if (currentActiveCaratItem) {
    const caratValueForURL = getItemCaratValue(currentActiveCaratItem);
    params.set("carat", caratValueForURL);
  }

  // Updates the URL without pushing a new history entry every time a click happens
  navigate({ search: params.toString() }, { replace: true });
}, [
  selectedMetal?.name, 
  selectedShape, 
  selectedStone, 
  selectedValues?.ProductCodes, 
  ProductCaratCodeData, // Added to track changes in data list
  product?.stoneTag,    // Added to track tag updates
  product?.productCode, // Added so Design Number stays in sync in the URL
  navigate
]);

 useEffect(() => {
  if (relatedData.length > 0 || checkboxes.length > 0) {
    const productCodeFromURL = queryParams.get("productCode");

    // 1️⃣ Metal
    if (metalFromURL) {
      const matchedMetal = relatedData.find((item) =>
        item.relatedItemNames
          .toLowerCase()
          .includes(metalFromURL.toLowerCase())
      );
      if (matchedMetal) {
        setSelectedMetal({
          key: matchedMetal.relatedItemKey,
          name: metalFromURL,
        });
      }
    } else if (!selectedMetal.name) {
      const firstAvailableMetal = metalOrder.find((metal) =>
        relatedData.some((item) => item.relatedItemKey.includes(metal))
      );
      if (firstAvailableMetal) {
        const matchedItem = relatedData.find((item) =>
          item.relatedItemKey.includes(firstAvailableMetal)
        );
        const firstVariation = matchedItem.relatedItemNames
          .split(",")[0]
          .trim();
        setSelectedMetal({
          key: matchedItem.relatedItemKey,
          name: firstVariation,
        });
      }
    }

    // 2️⃣ Shape
    if (shapeFromURL) {
      const shapeExists = checkboxes
        .filter((cb) => cb.tableName === "Shape")
        .some((cb) =>
          cb.values
            .split(",")
            .map((v) => v.trim().toLowerCase())
            .includes(shapeFromURL.toLowerCase())
        );
      if (shapeExists) {
        setSelectedShape(shapeFromURL);
      }
    } else if (!selectedShape) {
      const firstShape = checkboxes
        .filter((cb) => cb.tableName === "Shape")
        .flatMap((cb) => cb.values.split(",").map((v) => v.trim()))[0];
      if (firstShape) setSelectedShape(firstShape);
    }

    // 3️⃣ Diamond
    if (diamondFromURL) {
      const diamondExists = checkboxes
        .filter((cb) => cb.tableName === "Diamond")
        .some((cb) =>
          cb.values
            .split(",")
            .map((v) => v.trim().toLowerCase())
            .includes(diamondFromURL.toLowerCase())
        );
      if (diamondExists) {
        setSelectedStone(diamondFromURL);
      }
    } else if (!selectedStone) {
      const firstDiamond = checkboxes
        .filter((cb) => cb.tableName === "Diamond")
        .flatMap((cb) => cb.values.split(",").map((v) => v.trim()))[0];
      if (firstDiamond) setSelectedStone(firstDiamond);
    }

    // 4️⃣ Product Code / Carat Option from shared URL
    // 🔑 Guarded by urlProductCodeAppliedRef — this block should only drive
    // selection for the *initial* hydration of a given shared link. If left
    // unguarded it re-fires on every ProductCaratCodeData change (i.e. every
    // shape/stone switch) and can read a one-render-stale location.search,
    // overwriting a correctly re-matched carat with an old ProductCode that
    // doesn't exist in the new shape's data — which is why nothing appeared
    // selected after switching shapes.
    if (
      productCodeFromURL &&
      urlProductCodeAppliedRef.current !== productCodeFromURL
    ) {
      // Wait until the carat data for the current shape/stone has actually
      // loaded — otherwise there's nothing yet to validate the code
      // against. ProductCaratCodeData is a dependency below, so this will
      // simply run again once it arrives.
      if (ProductCaratCodeData && ProductCaratCodeData.length > 0) {
        const matchedCarat = ProductCaratCodeData.find(
          (item) => item.ProductCode === productCodeFromURL
        );

        if (matchedCarat) {
          setSelectedValues((prev) => ({
            ...prev,
            ProductCodes: productCodeFromURL,
          }));
          setCaratForImg(matchedCarat.Carat);
          // 🔑 Seed the "remembered carat" from the URL so that a later
          // shape/stone change tries to re-select this same carat instead
          // of silently falling back to the first option in the list.
          setSelectedCaratValue(getItemCaratValue(matchedCarat));

          const defaultSize =
            apiSizes?.find((s) => s.IsSelected)?.SizeValue ||
            apiSizes?.[0]?.SizeValue ||
            "N";

          // Triggers side actions to make sure layout calculations sync right up
          handleSelectedCarate(
            id,
            diamondFromURL || selectedStone,
            shapeFromURL || selectedShape,
            metalFromURL || selectedMetal.name,
            productCodeFromURL
          );

          fetchProductPrice(
            product?.id || id,
            metalFromURL || selectedMetal.name,
            defaultSize,
            diamondFromURL || selectedStone,
            shapeFromURL || selectedShape,
            productCodeFromURL,
            0
          );
        }

        // ✅ Mark this URL productCode as handled — whether or not it
        // matched this particular shape/stone's list — so we stop
        // re-consulting the URL from here on and let user interaction +
        // handleGettheCaratSelected's remembered-carat matching take over.
        urlProductCodeAppliedRef.current = productCodeFromURL;
      }
    }
  }

  // ✅ Once we've attempted to read metal/shape/diamond/productCode from the
  // incoming URL (whether or not each one matched), it's safe to let the
  // other effect start writing state back out to the URL.
  if (relatedData.length > 0 || checkboxes.length > 0) {
    initializedFromUrlRef.current = true;
  }
}, [
  relatedData,
  checkboxes,
  metalFromURL,
  shapeFromURL,
  diamondFromURL,
  location.search,
  ProductCaratCodeData,
  apiSizes,
  product?.id,
  id
]);
  useEffect(() => {
    const handleStorageChange = () => {
      const newView = localStorage.getItem("activeView") || "wholesale";
      setActiveView(newView);
      setViewVersion((v) => v + 1); // force re-render
    };

    const handleViewChange = (e) => {
      const newView =
        e.detail || localStorage.getItem("activeView") || "wholesale";
      setActiveView(newView);
      setViewVersion((v) => v + 1); // force re-render
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("viewChange", handleViewChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("viewChange", handleViewChange);
    };
  }, []);


  useEffect(() => {
    fetch(`${API_BASE_URL}/Product/GetProductDetailsByid?productId=${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setProduct(data.data.product);
          setCheckboxes(data.data.productCheckboxes);
          setRelatedData(data.data.productRelatedData);

        }
      })
      .catch((error) =>
        console.error("Error fetching product details:", error)
      );
  }, [id]);

  useEffect(() => {
    if (checkboxes.length > 0) {
      // Respect an incoming shared-link productCode instead of always
      // resetting it to the first checkbox option (this used to stomp the
      // value the URL-hydration effect had just set).
      const productCodeFromURL = queryParams.get("productCode");

      setSelectedValues((prev) => ({
        Clarity:
          checkboxes
            .find((cb) => cb.tableName === "Clarity")
            ?.values.split(",")[0] || "",
        Colour:
          checkboxes
            .find((cb) => cb.tableName === "Colour")
            ?.values.split(",")[0] || "",
        Certificate:
          checkboxes
            .find((cb) => cb.tableName === "Certificate")
            ?.values.split(",")[0] || "",
        Cutgrade:
          checkboxes
            .find((cb) => cb.tableName === "Cutgrade")
            ?.values.split(",")[0] || "",
        Polish:
          checkboxes
            .find((cb) => cb.tableName === "Polish")
            ?.values.split(",")[0] || "",
        Symmetry:
          checkboxes
            .find((cb) => cb.tableName === "Symmetry")
            ?.values.split(",")[0] || "",
        Fluo:
          checkboxes
            .find((cb) => cb.tableName === "Fluo")
            ?.values.split(",")[0] || "",
        // 🔑 FIX: actually use productCodeFromURL when present, instead of
        // always overwriting with the first checkbox option.
        ProductCodes:
          productCodeFromURL ||
          checkboxes
            .find((cb) => cb.tableName === "ProductCode")
            ?.values.split(",")[0] ||
          "",
      }));
    }
  }, [checkboxes]);

  const stoneValues =
    checkboxes
      ?.filter((checkbox) => checkbox.tableName === "Diamond")
      .flatMap((checkbox) => checkbox.values.split(",")) || [];

  useEffect(() => {
    if (stoneValues.length > 0 && !selectedStone) {
      setSelectedStone(stoneValues[0]);
    }
  }, [stoneValues]);
  useEffect(() => {
    if (checkboxes.length > 0 && DefaultProductimages?.values) {
      // Extract shape list from checkboxes
      const availableShapes = checkboxes
        .filter((checkbox) => checkbox.tableName === "Shape")
        .flatMap((checkbox) => checkbox.values.split(",").map((v) => v.trim()));

      // Extract the shape value from productImages.values (first part before comma)
      const productShape =
        DefaultProductimages.values.split(",")[0]?.trim() || "";

      // If productShape exists in availableShapes, set it as default, otherwise fallback to first available
      if (availableShapes.includes(productShape)) {
        setSelectedShape(productShape);
      } else if (availableShapes.length > 0) {
        setSelectedShape(availableShapes[0]); // fallback
      }
    }
  }, [checkboxes, DefaultProductimages]);

  useEffect(() => {
    if (selectedStone) {
      const clarityData = relatedData.find(
        (data) => data.relatedItemKey === selectedStone
      );
      if (clarityData) {
        const clarities = clarityData.relatedItemNames
          .split(",")
          .map((c) => c.trim());
        if (clarities.length > 0) {
          setSelectedValues((prev) => ({
            ...prev,
            Clarity: clarities[0],
          }));
        }
      }
    }
  }, [selectedStone, relatedData]);

  useEffect(() => {
    if (checkboxes.length > 0) {
      // Find the first available Band Width option
      const firstAvailableBandWidth =
        checkboxes
          .filter((checkbox) => checkbox.tableName === "Band")
          .flatMap((checkbox) => checkbox.values.split(","))[0]
          ?.trim() || "";

      if (firstAvailableBandWidth) {
        setSelectedBandWidth(firstAvailableBandWidth);
      }
    }
  }, [checkboxes]);

  useEffect(() => {
    if (relatedData.length > 0) {
      const firstAvailableMetal = metalOrder.find((metal) =>
        relatedData.some((item) => item.relatedItemKey.includes(metal))
      );

      if (firstAvailableMetal) {
        const matchedItem = relatedData.find((item) =>
          item.relatedItemKey.includes(firstAvailableMetal)
        );

        if (matchedItem) {
          const firstVariation = matchedItem.relatedItemNames
            .split(",")[0]
            .trim();

          setSelectedMetal({
            key: matchedItem.relatedItemKey, // Store relatedItemKey for API
            name: firstVariation, // Store variation for UI selection
          });
        }
      }
    }
  }, [relatedData]);

  useEffect(() => {
    if (relatedData.length > 0 || checkboxes.length > 0) {
      // 1️⃣ Metal
      if (metalFromURL) {
        const matchedMetal = relatedData.find((item) =>
          item.relatedItemNames
            .toLowerCase()
            .includes(metalFromURL.toLowerCase())
        );
        if (matchedMetal) {
          setSelectedMetal({
            key: matchedMetal.relatedItemKey,
            name: metalFromURL,
          });
        }
      } else if (!selectedMetal.name) {
        const firstAvailableMetal = metalOrder.find((metal) =>
          relatedData.some((item) => item.relatedItemKey.includes(metal))
        );
        if (firstAvailableMetal) {
          const matchedItem = relatedData.find((item) =>
            item.relatedItemKey.includes(firstAvailableMetal)
          );
          const firstVariation = matchedItem.relatedItemNames
            .split(",")[0]
            .trim();
          setSelectedMetal({
            key: matchedItem.relatedItemKey,
            name: firstVariation,
          });
        }
      }

      // 2️⃣ Shape
      if (shapeFromURL) {
        const shapeExists = checkboxes
          .filter((cb) => cb.tableName === "Shape")
          .some((cb) =>
            cb.values
              .split(",")
              .map((v) => v.trim().toLowerCase())
              .includes(shapeFromURL.toLowerCase())
          );
        if (shapeExists) {
          setSelectedShape(shapeFromURL);
        }
      } else if (!selectedShape) {
        const firstShape = checkboxes
          .filter((cb) => cb.tableName === "Shape")
          .flatMap((cb) => cb.values.split(",").map((v) => v.trim()))[0];
        if (firstShape) setSelectedShape(firstShape);
      }

      // 3️⃣ Diamond
      if (diamondFromURL) {
        const diamondExists = checkboxes
          .filter((cb) => cb.tableName === "Diamond")
          .some((cb) =>
            cb.values
              .split(",")
              .map((v) => v.trim().toLowerCase())
              .includes(diamondFromURL.toLowerCase())
          );
        if (diamondExists) {
          setSelectedStone(diamondFromURL);
        }
      } else if (!selectedStone) {
        const firstDiamond = checkboxes
          .filter((cb) => cb.tableName === "Diamond")
          .flatMap((cb) => cb.values.split(",").map((v) => v.trim()))[0];
        if (firstDiamond) setSelectedStone(firstDiamond);
      }
    }
  }, [relatedData, checkboxes, metalFromURL, shapeFromURL, diamondFromURL]);

  //RESET base metal weight when metal changes
  useEffect(() => {
    setApiMetalWeight(0);
    setMetalVersion(v => v + 1); // 🔑 force freshness
  }, [selectedMetal?.name]);
  useEffect(() => {
    if (!product?.id) return;
    if (!selectedMetal?.name) return;
    if (!selectedStone) return;
    if (!selectedShape) return;
    if (!selectedValues?.ProductCodes) return;

    // 🔑 DEFAULT PRICE (base metal weight only)
    fetchProductPrice(
      product.id,
      selectedMetal.name,
      selectedSize || "N",   // default size
      selectedStone,
      selectedShape,
      selectedValues.ProductCodes,
      0         // 👈 ALWAYS base weight here
    );
  }, [
    product?.id,
    selectedMetal?.name,
    selectedStone,
    selectedShape,
    selectedValues?.ProductCodes,
    metalVersion
  ]);


  const handleSizeChange = (e) => {
    const sizeValue = e.target.value;
    setSelectedSize(sizeValue);

    const sizeObj = apiSizes.find(s => s.SizeValue === sizeValue);
    if (!sizeObj) return;

    // 🔑 Calculate weight ONLY here
    const newWeight = adjustMetalWeight(sizeObj);

    fetchProductPrice(
      product.id,
      selectedMetal.name,
      sizeValue,
      selectedStone,
      selectedShape,
      selectedValues.ProductCodes,
      newWeight
    );
  };

  const fetchProductPrice = async (
    productId,
    metalKT,
    size,
    selectedStone,
    selectedShape,
    ProductCode,
    metalWeight
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ProductId: productId,
        MetalKT: metalKT,
        Size: size,
        Diamond: selectedStone,
        Shape: selectedShape,
        ProductCode: ProductCode,
        MetalWeight: metalWeight?.toString() ?? "",
      });

      console.log("queryParams", queryParams.toString());

      const response = await fetch(
        `${API_BASE_URL}/product/GetProductPrice?${queryParams}`
      );
      const data = await response.json();

      if (response.ok) {
        const apiPrice = data.data || {};
        console.log(apiPrice)
        // 🔑 CAPTURE BASE METAL WEIGHT ONLY ONCE
        if (apiPrice.metalweight > 0) {
          setApiMetalWeight(apiPrice.metalweight);
        }
        setPricedata({
          ...apiPrice,
          metalweight: apiPrice.metalweight,
          MetalWeight: apiPrice.metalweight,
        });
      } else {
        console.error("Error:", data.message);
        setPricedata(null);
      }
    } catch (error) {
      console.error("API call failed:", error);
      setPricedata(null);
    }
  };



const fetchWishlist = async () => {
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const userId = storedUser?.userId || 0;
  const companyid = storedUser?.companyId || 0;

  // FIX: was `if (userId) return;` — inverted, which meant logged-in users
  // never fetched their wishlist. Should only skip when there's no userId.
  if (!companyid) return;

  try {
    const res = await fetch(
      `${API_BASE_URL}/Order/GetWishlist?userId=${userId}&CompanyId=${companyid}`
    );
    if (!res.ok) {
      console.error("Failed to fetch wishlist:", res.status);
      return;
    }
    const data = await res.json();

    const items = (Array.isArray(data) ? data : []).map((item) => ({
      WishlistID: item.wishlistID,
      ProductID: item.productID,
      ProductCode: item.productCode,
      MetalKT: item.metalName,
      Shape: item.shape,
    }));
    setWishlist(items);
  } catch (err) {
    console.error("Error fetching wishlist:", err);
  }
};
  useEffect(() => {

    fetchWishlist();
  }, []);

  // ❌ REMOVED: this effect used to unconditionally reset ProductCodes /
  // caratForImg to ProductCaratCodeData[0] every time the carat list
  // changed — which stomped both the URL-provided productCode/carat AND
  // the "remembered carat" logic below. handleGettheCaratSelected() now
  // owns setting these values (match-remembered-carat-or-default), so this
  // effect is gone.

  useEffect(() => {
    fetch(`${API_BASE_URL}/InStock/GetProductInvetoryDetails`) // replace with your real API endpoint
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 200 && data.data) {
          setProductStockData(data.data);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  // ===========================
  // FETCH SIZES FROM MASTER API Need tp pass the apiMetalWeight and categryname
  // ===========================

  useEffect(() => {
    if (!product?.categoryName || apiMetalWeight === null) return;

    const params = new URLSearchParams({
      sizeCountry: "AU",
      categoryName: product.categoryName,
      checkValue: apiMetalWeight
    });

    console.log("data size", params.toString())
    fetch(`${API_BASE_URL}/master/Get?${params.toString()}`)
      .then(res => res.json())
      .then(data => {
        if (!data.status || !Array.isArray(data.data)) return;

        setApiSizes(data.data);

        // default size
        const selected =
          data.data.find(s => s.IsSelected) || data.data[0];

        if (selected) {
          setSelectedSize(selected.SizeValue);
        }
      })
      .catch(err => console.error("Size API Error:", err));
  }, [product?.categoryName, apiMetalWeight]);


  // =======================================
  // CALCULATE + APPLY METAL WEIGHT CHANGE pricedata?.metalmeight
  // =======================================
  function adjustMetalWeight(sizeItem) {
    if (!sizeItem) return apiMetalWeight;

    const baseWeight = apiMetalWeight || 0;

    // DisplayName contains + / - adjustment
    const adjustment = parseFloat(sizeItem.DisplayName || 0);

    const calculatedWeight = baseWeight + adjustment;

    return calculatedWeight;
  }



  // =======================================
  // HANDLE SIZE CHANGE FROM DROPDOWN
  // =======================================


  const openPopup = (id) => {
    //console.log("Opening popup with ID:", id); // Debugging
    setContentId(id);
    setPopupOpen(true);
  };

  const closePopup = () => {
    // console.log("Closing popup");
    setPopupOpen(false);
    setContentId(null);
  };

  const handleButtonClick = (category, value) => {
    setSelectedValues((prev) => ({ ...prev, [category]: value }));
  };

  const handleSelected = (selectedOption, type) => {
    if (type === "shape") {
      setSelectedShape(selectedOption);
    } else if (type === "band") {
      setSelectedBandWidth(selectedOption);
    } else if (type === "metal") {
      setSelectedMetal({ key: selectedOption, name: selectedOption }); // Update key and name
    }
  };




  const handleSelectedCarate = (
    productid,
    selectedStone,
    shapeName,
    metalKT,
    productcode
  ) => {
    setLoading(true);
    //const caratDecimal = parseFloat(carat);
    console.log("Carat API Request:", productid,
      selectedStone,
      shapeName,
      metalKT,
      productcode);
    axios
      .get(`${API_BASE_URL}/Product/Getshapewithcrt`, {
        params: {
          productId: productid,
          Diamondtype: selectedStone,
          shapeName: shapeName,
          metalKT: metalKT,
          productcode: productcode,
          carat: 0,
        },
      })
      .then((response) => {
        if (
          response.data &&
          response.data.success &&
          Array.isArray(response.data.data)
        ) {
          console.log("Carat API response:", response.data.data);
          setProductCaratData(response.data.data);
        } else {
          console.error("Invalid API response:", response.data);
          setProductCaratData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching product data:", error);
        setProductCaratData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [isStockVisible, setIsStockVisible] = useState(false);
  const toggleStock = () => setIsStockVisible((prev) => !prev);

  // 🔑 UPDATED: when the carat list for a new shape/stone comes back, try to
  // keep the previously-selected carat/size value. If that exact carat
  // exists in the new list, select it; otherwise fall back to the first
  // (default) item. This is the single place that decides ProductCodes /
  // caratForImg from ProductCaratCodeData, replacing the old effect that
  // always jumped to caratData[0].
  const handleGettheCaratSelected = (productid, selectedStone, shapeName) => {
  setLoading(true);
  axios
    .get(`${API_BASE_URL}/Product/GetDaimondwithcrt`, {
      params: {
        productId: productid,
        Diamondtype: selectedStone,
        shapeName: shapeName,
      },
    })
    .then((response) => {
      if (
        response.data &&
        response.data.success &&
        Array.isArray(response.data.data)
      ) {
        const caratData = response.data.data;
        setProductCaratCodeData(caratData);

        if (caratData.length > 0) {
          let matchedItem = null;
          if (
            selectedCaratValue !== null &&
            selectedCaratValue !== undefined &&
            selectedCaratValue !== ""
          ) {
            matchedItem = caratData.find(
              (item) =>
                String(getItemCaratValue(item)) === String(selectedCaratValue)
            );
          }

          const chosenItem = matchedItem || caratData[0];

          // 🔑 Set active ProductCode directly
          setSelectedValues((prev) => ({
            ...prev,
            ProductCodes: chosenItem.ProductCode,
          }));
          setCaratForImg(chosenItem.Carat);
          setSelectedCaratValue(getItemCaratValue(chosenItem));

          // Fetch price & diamond details with the new chosen item's code
          handleSelectedCarate(
            productid,
            selectedStone,
            shapeName,
            selectedMetal?.name,
            chosenItem.ProductCode
          );

          fetchProductPrice(
            productid,
            selectedMetal?.name,
            selectedSize || "N",
            selectedStone,
            shapeName,
            chosenItem.ProductCode,
            0
          );
        }
      } else {
        setProductCaratCodeData([]);
        setSelectedValues((prev) => ({ ...prev, ProductCodes: "" }));
      }
    })
    .catch(() => {
      setProductCaratCodeData([]);
      setSelectedValues((prev) => ({ ...prev, ProductCodes: "" }));
    })
    .finally(() => setLoading(false));
};

  useEffect(() => {
    if (selectedStone && selectedShape && selectedMetal?.name) {
      handleGettheCaratSelected(id, selectedStone, selectedShape);
    }
  }, [id, selectedStone, selectedShape]);

  useEffect(() => {
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, [imagesData]); // Re-run when imagesData updates

  const sizeCategories = ["Bracelets", "Necklace", "Ring"];
  const filteredSizes =
    relatedData?.filter((item) =>
      sizeCategories.includes(item.relatedItemKey)
    ) || [];

  useEffect(() => {
    // Wait until sizes are loaded
    if (!selectedSize && filteredSizes.length > 0) {
      const defaultCategory = filteredSizes[0];
      const defaultOptions = defaultCategory.relatedItemNames?.split(",") || [];
      const defaultSize = defaultOptions[0]?.trim();

      if (defaultSize) {
        setSelectedSize(defaultSize); // This will trigger the next useEffect below
      }
    }
  }, [filteredSizes]);

  useEffect(() => {
    if (selectedShape && selectedMetal?.name) {
      setLoadingImages(true);
      const cleanBandWidth = (selectedBandWidth || "").trim();
      const parts = [selectedShape, selectedMetal.name];
      if (cleanBandWidth) parts.push(cleanBandWidth);
      // parts.push(selectedStone);
      if (caratforimg) parts.push(caratforimg);
      const selectedprodctcode = selectedValues?.ProductCodes;
      const selectedimgValues = parts.join(",");
      const selectedData = {
        productId: product?.id,
        value: selectedimgValues,
        productCode: selectedprodctcode,
      };

      fetch(`${API_BASE_URL}/Product/GetProductImages`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(selectedData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            const productImages = data.data?.productImages || [];
            if (productImages.length > 0) {
              const imageList = productImages[0].imagesNames
                .split(",")
                .map((img) => `${Image_URL}UatProduct/${img.trim()}`);
              setImagesData(imageList);
            } else {
              // 🟡 Fallback to default images if no variant images found
              const fallbackList =
                DefaultProductimages?.imagesNames
                  ?.split(",")
                  .map((img) => `${Image_URL}UatProduct/${img.trim()}`) || [];
              setImagesData(fallbackList);
            }
          } else {
            console.error("Error retrieving product images:", data.message);

            // 🟡 Fallback in case of error too
            // const fallbackList =
            //     DefaultProductimages?.imagesNames
            //         ?.split(",")
            //         .map(img => `${Image_URL}UatProduct/${img.trim()}`) || [];
            // setImagesData(fallbackList);
            setImagesData([]);
          }
        })
        .catch((error) => {
          console.error("Error with API call:", error);

          // 🟡 Fallback in case of API failure
          const fallbackList =
            DefaultProductimages?.imagesNames
              ?.split(",")
              .map((img) => `${Image_URL}UatProduct/${img.trim()}`) || [];
          setImagesData(fallbackList);
        })
        .finally(() => setLoadingImages(false)); // stop loading;
    }
  }, [
    selectedShape,
    selectedMetal?.name,
    selectedBandWidth,
    selectedStone,
    caratforimg,
    DefaultProductimages,
    selectedValues?.ProductCodes,
  ]);

  useEffect(() => {
    if (selectedStone && productcaratData.length > 0) {
      const matchedItem = productcaratData.find(
        (item) => item.DiamondName === selectedStone
      );
      if (matchedItem) {
        setSelectedValues((prev) => ({
          ...prev,
          Colour: matchedItem.ColorName,
          Clarity: matchedItem.ClarityName, // assuming you have this
        }));
      }
    }
  }, [selectedStone, productcaratData]);
  // 🔥 Sync finalPrice with displayed price logic

  useEffect(() => {
    if (!pricedata?.price) return;

    let basePrice = pricedata.price;

    // 🌟 Apply markup if activeView = retail
    const activeView = localStorage.getItem("activeView") || "wholesale";
    const storedPayload = JSON.parse(
      localStorage.getItem("priceTable_seller") || "{}"
    );
    const storedTable = Array.isArray(storedPayload.data)
      ? storedPayload.data
      : [];

    if (activeView === "retail" && storedTable.length > 0) {
      const range = storedTable.find((row) => {
        const from = parseFloat(row.from || 0);
        const to = row.to === null ? Infinity : parseFloat(row.to);
        return basePrice >= from && basePrice <= to;
      });

      if (range) {
        const markupPercent = parseFloat(range.markup || 0);
        basePrice = basePrice * markupPercent;
      }
    }

    // 💱 Convert to selected currency
    const converted = basePrice * (selectedCurrency?.price || 1);

    setFinalPrice(converted);
  }, [pricedata, selectedCurrency]);

  useEffect(() => {
    fetch(API_BASE_URL + "/Master/GetClaritys")
      .then(res => res.json())
      .then(res => {
        if (res.success) {
          setAllClarities(res.data);
        }
      });
  }, []);
  const selectedColour =
    productcaratData?.find(
      (x) => x.DiamondName === selectedStone
    )?.ColorName || "";
  useEffect(() => {
    fetch(API_BASE_URL + "/Master/GetColour")
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setAllColours(res.data);
        }
      })
      .catch(console.error);
  }, []);
  const selectedCertificate =
    productcaratData?.find(
      (x) => x.DiamondName === selectedStone
    )?.CertificateName || "";

  useEffect(() => {
    fetch(API_BASE_URL + "/Master/GetCertificate")
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setAllCertificates(res.data);
        }
      })
      .catch(console.error);
  }, []);

  const shouldShowPOR = useMemo(() => {
    if (selectedStone !== "Natural Diamond") return false;
    if (!Array.isArray(productcaratData)) return false;

    const naturalDiamondRows = productcaratData.filter(
      x => x.DiamondName === "Natural Diamond"
    );

    const maxCarat = Math.max(
      ...naturalDiamondRows.map(r => Number(r.StoneCrt1 || 0))
    );

    return maxCarat >= 0.98;
  }, [productcaratData, selectedStone]);



  if (!product) {
    return <div>Loading...</div>;
  }
  if (loadingImages) return <div>Loading...</div>;

  // **Thumbnail Slider Settings**
  const thumbnailSettings = {
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
    asNavFor: nav1, // 🔹 Ensure thumbnails sync with main image
    lazyLoad: "ondemand",
    arrows: false,
  };

  // **Main Image Slider Settings**
  const mainImageSettings = {
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: nav2, // 🔹 Ensure main image syncs with thumbnails
    lazyLoad: "ondemand",
    beforeChange: (oldIndex, newIndex) => setActiveIndex(newIndex),
  };
  const popupSliderSettings = {
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <PopupNextArrow />,
    prevArrow: <PopupPrevArrow />,
    lazyLoad: "ondemand",
    initialSlide: activeIndex, // 🔥 important
  };
  const handleThumbnailClick = (index) => {
    setActiveIndex(index);
    nav1.slickGoTo(index);
  };

  const limitWords = (html, wordLimit) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || div.innerText || "";
    const words = text.split(/\s+/).slice(0, wordLimit).join(" ");
    return words + (text.split(/\s+/).length > wordLimit ? "..." : "");
  };
  const selectedOptions = {
    productimg: imagesData[activeIndex],
    shape: selectedShape,
    bandWidth: selectedBandWidth,
    metal: selectedMetal.name,
    carat: caratforimg,
    stone: selectedStone,
    Productcodes: selectedValues.ProductCodes,
  };
  const addToCart = (product) => {
    let basePrice = pricedata.price;
    // Create the cart item with selected options
    const activeImage = imagesData[activeIndex];
    const engraveInput = document.getElementById("engrave");
    const engraveValue = engraveInput ? engraveInput.value.trim() : "";
    // const cartItem = {
    //     ...product,
    //const finalPrice =(pricedata?.price ?? product.productPrice ?? 0) * (selectedCurrency?.price || 1);

    const cartItem = {
      ...product,
      Currency: selectedCurrency.name,
      ProductNewprice: Math.round(finalPrice),
      productCartPrice: basePrice,
      productCheckoutPrice: basePrice, // ✅ override with your price logic
      selectedOptions: {
        productimg: activeImage,
        shape: selectedShape,
        bandWidth: selectedBandWidth,
        metal: selectedMetal.name,
        carat: caratforimg,
        stone: selectedStone,
        ringSize: selectedSize,
        newmetalWeight: apiMetalWeight || 0,
        engrave: engraveValue,
        productCodes: selectedValues.ProductCodes,
      },
      selectedValues,
      quantity: 1,
      engravingPrice: 0, //engraveValue ? 2 : 0
    };

    let cart = JSON.parse(localStorage.getItem("cart")) || [];

    // Check if the exact product (with the same selected options) already exists in the cart
    const existingIndex = cart.findIndex(
      (item) =>
        item.id === product.id &&
        item.selectedOptions.productimg ===
        cartItem.selectedOptions.productimg &&
        item.selectedOptions.shape === cartItem.selectedOptions.shape &&
        item.selectedOptions.bandWidth === cartItem.selectedOptions.bandWidth &&
        item.selectedOptions.metal === cartItem.selectedOptions.metal &&
        item.selectedOptions.carat === cartItem.selectedOptions.carat &&
        item.selectedOptions.stone === cartItem.selectedOptions.stone &&
        item.selectedOptions.ringSize === cartItem.selectedOptions.ringSize &&
        item.selectedOptions.productCodes === cartItem.selectedOptions.productCodes
    );

    if (existingIndex !== -1) {
      alert("Product already exists in the cart!");
      navigate("/cart");
    } else {
      cart.push(cartItem);

      localStorage.setItem("cart", JSON.stringify(cart));
      navigate("/cart");
      // alert("Product added to cart!");
    }
  };

  const CheckOut = (product) => {
    let basePrice = pricedata.price;
    // Create the cart item with selected options
    const activeImage = imagesData[activeIndex];
    const engraveInput = document.getElementById("engrave");
    const engraveValue = engraveInput ? engraveInput.value.trim() : "";
    // const cartItem = {
    //     ...product,
    // const finalPrice =(pricedata?.price ?? product.productPrice ?? 0) * (selectedCurrency?.price || 1);

    const cartItem = {
      ...product,
      Currency: selectedCurrency.name,
      ProductNewprice: Math.round(finalPrice),
      productCartPrice: basePrice,
      productCheckoutPrice: basePrice, // ✅ override with your price logic
      selectedOptions: {
        productimg: activeImage,
        shape: selectedShape,
        bandWidth: selectedBandWidth,
        metal: selectedMetal.name,
        carat: caratforimg,
        stone: selectedStone,
        ringSize: selectedSize,
        newmetalWeight: apiMetalWeight || 0,
        engrave: engraveValue,
        productCodes: selectedValues.ProductCodes,
      },
      selectedValues,
      quantity: 1,
      engravingPrice: 0, //engraveValue ? 2 : 0
    };

    let cart = JSON.parse(localStorage.getItem("cart")) || [];

    // Check if the exact product (with the same selected options) already exists in the cart
    const existingIndex = cart.findIndex(
      (item) =>
        item.id === product.id &&
        item.selectedOptions.productimg ===
        cartItem.selectedOptions.productimg &&
        item.selectedOptions.shape === cartItem.selectedOptions.shape &&
        item.selectedOptions.bandWidth === cartItem.selectedOptions.bandWidth &&
        item.selectedOptions.metal === cartItem.selectedOptions.metal &&
        item.selectedOptions.carat === cartItem.selectedOptions.carat &&
        item.selectedOptions.stone === cartItem.selectedOptions.stone &&
        item.selectedOptions.ringSize === cartItem.selectedOptions.ringSize &&
        item.selectedOptions.productCodes ===
        cartItem.selectedOptions.productCodes
    );

    if (existingIndex !== -1) {
      alert("Product already exists in the cart!");
      navigate("/cart");
    } else {
      cart.push(cartItem);

      localStorage.setItem("cart", JSON.stringify(cart));
      //alert("Product added to cart!");
      navigate("/cart");
    }
  };

  if (!selectedCurrency) return null;

const normalizeMetalWithKt = (metal) => {
  if (!metal) return metal;
  if (/\d+\s*k\b/i.test(metal)) return metal.trim();
  if (/(gold|platinum|silver)/i.test(metal)) return `9K ${metal}`.trim();
  return metal;
};
  // const isInWishlist = wishlist.includes(product.id);
 const isInWishlist = wishlist.some(
  (w) =>
    w.ProductID === product.id &&
    w.ProductCode === selectedValues.ProductCodes &&
    w.MetalKT === normalizeMetalWithKt(selectedMetal?.name) &&
    w.Shape === selectedShape
)


  const addToWishlist = async (productId) => {
  // FIX: prevent double-fire from rapid clicks before the first request resolves
  if (wishlistPending) return;

  try {
    setWishlistPending(true);

    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const userId = storedUser?.userId ?? 0;
    const companyId = storedUser?.companyId ?? 0;

    if (!selectedValues.ProductCodes || !selectedMetal?.name || !selectedShape) {
      alert("Please select metal, shape and carat option");
      return;
    }

    const normalizedMetal = normalizeMetalWithKt(selectedMetal.name);

    // FIX: compare against the normalized MetalKT, consistent with isInWishlist
    const existingItem = wishlist.find(
      (w) =>
        w.ProductID === productId &&
        w.ProductCode === selectedValues.ProductCodes &&
        w.MetalKT === normalizedMetal &&
        w.Shape === selectedShape
    );

    // ==========================
    // REMOVE
    // ==========================
    if (existingItem) {
      // FIX: RemoveWishlist requires UserID + CompanyId, not just WishlistID
      const res = await fetch(
        `${API_BASE_URL}/Order/RemoveWishlist?WishlistID=${existingItem.WishlistID}&UserID=${userId}&CompanyId=${companyId}`,
        { method: "DELETE" }
      );

      if (!res.ok) {
        console.error("Failed to remove wishlist item:", res.status);
        return;
      }

      const data = await res.json();
      if (data?.success) {
        setWishlist((prev) =>
          prev.filter((w) => w.WishlistID !== existingItem.WishlistID)
        );
      }
      return;
    }

    // ==========================
    // ADD
    // ==========================
    const payload = {
      UserID: userId,
      CompanyId: companyId,
      ProductID: productId,
      ProductCode: selectedValues.ProductCodes,
      MetalKT: normalizedMetal,
      Shape: selectedShape,
      ImageUrl: imagesData[activeIndex] || "",
    };

    const res = await fetch(`${API_BASE_URL}/Order/AddWishlist`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      console.error("Failed to add wishlist item:", res.status);
      return;
    }

    const data = await res.json();
    if (data?.success) {
      fetchWishlist();
    }
  } catch (err) {
    console.error("Wishlist error:", err);
  } finally {
    setWishlistPending(false);
  }
};
  const seenSizes = new Set();

  const uniqueItems = (ProductCaratCodeData || []).filter(item => {
    if (product?.stoneTag?.includes("Colour Stone MM Size")) {
      if (seenSizes.has(item.sizeMM)) return false;
      seenSizes.add(item.sizeMM);
      return true;
    }
    return true;
  });
  const finalCaratRounded = Number(
    (productcaratData || []).reduce((s, i) => s + (Number(i.StoneCrt) || 0), 0).toFixed(2)
  );





  return (
    <div>
      <div className="home">
        <div id="page" className="hfeed page-wrapper">
          <Header />
          <div id="site-main" className="site-main">
            <div id="main-content" className="main-content">
              <div id="primary" className="content-area">
                <div id="content" className="site-content" role="main">
                  <div
                    className="shop-details zoom"
                    data-product_layout_thumb="scroll"
                    data-zoom_scroll="true"
                    data-zoom_contain_lens="true"
                    data-zoomtype="inner"
                    data-lenssize="200"
                    data-lensshape="square"
                    data-lensborder=""
                    data-bordersize="2"
                    data-bordercolour="#f9b61e"
                    data-popup="false"
                  >
                    <div className="product-top-info">
                      <div className="section-padding">
                        <div className="section-container p-l-r">
                          <div className="row" id="scroll-row">
                            <div className="product-images col-lg-7 col-md-12 col-12">
                              <div className="process text-center">
                                {loadingImages ? (
                                  <div className="loading-spinner">
                                    <div className="spinner"></div>
                                  </div>
                                ) : (
                                  <div className="floating-input-container">
                                    <div className="row">
                                      {/* Thumbnail Images */}
                                      <div className="col-md-2">
                                        <Slider
                                          {...thumbnailSettings}
                                          ref={(slider) => setNav2(slider)}
                                        >
                                          {imagesData.map((src, index) => (
                                            <div
                                              key={index}
                                              className={`img-item slick-cloned border ${activeIndex === index
                                                ? "active-thumbnail"
                                                : ""
                                                }`}
                                              onClick={() =>
                                                handleThumbnailClick(index)
                                              }
                                            >
                                              <span className="img-thumbnail-scroll">
                                                <img
                                                  width="600"
                                                  height="600"
                                                  src={src}
                                                  alt={`Thumbnail ${index + 1}`}
                                                />
                                              </span>
                                            </div>
                                          ))}
                                        </Slider>
                                      </div>

                                      {/* Main Image Display */}
                                      <div className="col-md-10">
                                        <Slider
                                          {...mainImageSettings}
                                          ref={(slider) => setNav1(slider)}
                                        >
                                          {imagesData.map((src, index) => (
                                            <div
                                              className="img-item"
                                              key={index}
                                            >
                                              <img
                                                width="900"
                                                height="900"
                                                src={src}
                                                alt={`Main Image ${index + 1}`}
                                                onClick={() => setIsImagePopupOpen(true)}
                                              />
                                            </div>
                                          ))}
                                        </Slider>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-md-12 col-lg-5 orderlg-1 order-2">
                              <div className="why-us-row row justify-content-center">
                                <div className="col-md-12">
                                  <div className="row g-4">
                                    <div className="col-12 col-md-12 col-lg-12">
                                      <div
                                        className="why-us-card"
                                        data-aos="fade-up"
                                        data-aos-duration="800"
                                      >
                                        <div className="why-us-inner">
                                          <div className="top_details">
                                            <br></br>
                                            <h1 className="title">
                                              {selectedValues.ProductCodes}
                                            </h1>
                                            {/* <p> Product Code :{" "}{selectedValues.ProductCodes}  </p>*/}


                                            <p>{product.categoryName}
                                            </p>



                                            <span className="price">
                                              <ins style={{ boxShadow: 'none' }}>
                                                {shouldShowPOR ? (
                                                  <>
                                                    <button
                                                      className="product-btn"
                                                      id="priceOnReq"
                                                      style={{

                                                        padding: 8,
                                                        borderRadius: 6,
                                                      }}
                                                      onClick={() =>
                                                        setShowPopup(true)
                                                      }
                                                    >
                                                      Price On Request
                                                    </button>

                                                    {pareValue && (
                                                      <p className="text-sm text-gray-600 mt-1">
                                                        {selectedCurrency?.name === "GBP" ? selectedCurrency?.name : `${selectedCurrency?.name} $`}{" "}
                                                        {Math.round(finalPrice)}
                                                      </p>
                                                    )}
                                                  </>
                                                ) : (
                                                  <span>
                                                    {selectedCurrency?.name === "GBP" ? selectedCurrency?.name : `${selectedCurrency?.name} $`}{" "}
                                                    {(() => {
                                                      let basePrice =
                                                        pricedata?.price || 0;
                                                      const activeView =
                                                        localStorage.getItem(
                                                          "activeView"
                                                        ) || "wholsale ";
                                                      const storedPayload =
                                                        JSON.parse(
                                                          localStorage.getItem(
                                                            "priceTable_seller"
                                                          ) || "{}"
                                                        );
                                                      const storedTable =
                                                        Array.isArray(
                                                          storedPayload.data
                                                        )
                                                          ? storedPayload.data
                                                          : [];

                                                      if (
                                                        activeView === "retail" &&
                                                        storedTable.length > 0
                                                      ) {
                                                        const range =
                                                          storedTable.find(
                                                            (row) => {
                                                              const from =
                                                                parseFloat(
                                                                  row.from || 0
                                                                );
                                                              const to =
                                                                row.to === null
                                                                  ? Infinity
                                                                  : parseFloat(
                                                                    row.to
                                                                  );
                                                              return (
                                                                basePrice >=
                                                                from &&
                                                                basePrice <= to
                                                              );
                                                            }
                                                          );

                                                        if (range) {
                                                          const markupPercent =
                                                            parseFloat(
                                                              range.markup || 0
                                                            );
                                                          const newPrice =
                                                            basePrice *
                                                            markupPercent; //basePrice + (basePrice * markupPercent) / 100;
                                                          basePrice = newPrice;
                                                        }
                                                      }

                                                      const finalPrice =
                                                        basePrice * selectedCurrency?.price;
                                                      return Math.round(
                                                        finalPrice
                                                      );
                                                    })()}
                                                  </span>
                                                )}
                                              </ins>
                                            </span>
                                          </div>

                                          <div className="in-stock">
                                            {selectedValues.ProductCodes &&
                                              productStockData?.find(
                                                (item) =>
                                                  item.ProductCode ===
                                                  selectedValues.ProductCodes
                                              ) && (
                                                <button
                                                  id="in-stock-toggle"
                                                  className="in-stock-button"
                                                  onClick={toggleStock}
                                                >
                                                  In-Stock{" "}
                                                  <span id="toggle-icon">
                                                    {isStockVisible ? "−" : "+"}
                                                  </span>
                                                </button>
                                              )}

                                            {/* Show table only if isStockVisible is true */}
                                            {isStockVisible && (
                                              <div id="custom-product-options2">
                                                <div className="table-container">
                                                  <table className="custom-table">
                                                    <thead>
                                                      <tr>
                                                        <th>Metal Colour</th>
                                                        <th>Metal KT</th>
                                                        <th>QTY</th>
                                                        <th>Carat</th>
                                                        <th
                                                          className="text-center"
                                                          onClick={() =>
                                                            addToCart(product)
                                                          }
                                                        >
                                                          Buy
                                                        </th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {productStockData
                                                        ?.filter(
                                                          (item) =>
                                                            item.ProductCode ===
                                                            selectedValues.ProductCodes
                                                        )
                                                        ?.map((item, index) => {

                                                          const selectedCarat =
                                                            ProductCaratCodeData?.find(
                                                              (c) =>
                                                                c.ProductCode ===
                                                                selectedValues.ProductCodes
                                                            )?.Carat || "";

                                                          return (
                                                            <tr key={index}>
                                                              <td>
                                                                {
                                                                  item.MetalColor
                                                                }
                                                              </td>
                                                              <td>
                                                                {item.MetalKT}
                                                              </td>
                                                              <td>
                                                                {item.Quantity}
                                                              </td>
                                                              <td>
                                                                {selectedCarat}
                                                              </td>
                                                              <td className="text-center">
                                                                <button className="buy-button">
                                                                  Buy
                                                                </button>
                                                              </td>
                                                            </tr>
                                                          );
                                                        })}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            )}
                                          </div>

                                          <div className="custom-button-container">
                                            <button
                                              className="custom-option-button active"
                                              id="option1"
                                              data-target=".custom-product-options"
                                            >
                                              Customise your product
                                            </button>
                                            <button
  onClick={() => addToWishlist(product.id)}
  disabled={wishlistPending}
  style={{
    backgroundColor: isInWishlist ? "#373737" : "white",
    color: isInWishlist ? "white" : "black",
    width: "200px",
    border: "1px solid #d9d9d9",
    padding: "8px 12px",
    borderRadius: "6px",
    cursor: wishlistPending ? "not-allowed" : "pointer",
    opacity: wishlistPending ? 0.6 : 1,
    boxShadow: "1px 1px 5px #ccc",
  }}
>
  {isInWishlist ? "❤️ Added in Wishlist" : "🤍 Add to Wishlist"}
</button>
                                          </div>
                                          <div className="content-container">
                                            <div className="custom-product-options">
                                              <div className="metal-selection">
                                                <label className="option-label" id="label-info-icon">
                                                  Metal
                                                </label>

                                                <div className="typeAndOptions">
                                                  {/* STEP 1 — Metal Type Images */}
                                                  <div className="metal-type-options">
                                                    {metalOrder.map(
                                                      (metalType) => {
                                                        const hasMetal =
                                                          relatedData.some(
                                                            (item) =>
                                                              item.relatedItemKey
                                                                .toLowerCase()
                                                                .includes(
                                                                  metalType.toLowerCase()
                                                                )
                                                          );
                                                        if (!hasMetal)
                                                          return null;

                                                        // Generate image file name (e.g., "whitegold.png")
                                                        const imageName =
                                                          metalType
                                                            .toLowerCase()
                                                            .replace(/\s+/g, "") +
                                                          ".png";
                                                        const imageUrl = `https://westendjewellery.com/assets/img/${imageName}`;

                                                        return (
                                                          <div
                                                            key={metalType}
                                                            className="metal-type-item"
                                                          >
                                                            <button
                                                              className={`metal-type-btn ${selectedMetal.key
                                                                ?.toLowerCase()
                                                                .includes(
                                                                  metalType.toLowerCase()
                                                                )
                                                                ? "selected"
                                                                : ""
                                                                }`}
                                                              onClick={() => {
                                                                const matchedItem =
                                                                  relatedData.find(
                                                                    (item) =>
                                                                      item.relatedItemKey
                                                                        .toLowerCase()
                                                                        .includes(
                                                                          metalType.toLowerCase()
                                                                        )
                                                                  );
                                                                if (matchedItem) {
                                                                  const firstVariation =
                                                                    matchedItem.relatedItemNames
                                                                      .split(
                                                                        ","
                                                                      )[0]
                                                                      .trim();
                                                                  setSelectedMetal(
                                                                    {
                                                                      key: matchedItem.relatedItemKey,
                                                                      name: firstVariation,
                                                                    }
                                                                  );
                                                                }
                                                              }}
                                                            >
                                                              <img
                                                                style={{
                                                                  width: 25,
                                                                }}
                                                                src={imageUrl}
                                                                alt={metalType}
                                                                className="metal-type-img"
                                                              />
                                                            </button>
                                                            <p className="metal-type-label">
                                                              {metalType}
                                                            </p>
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                  </div>

                                                  {/* STEP 2 — Karat (KT) Options for Selected Metal */}
                                                  <div className="metal-options">
                                                    {relatedData
                                                      .filter(
                                                        (item) =>
                                                          selectedMetal.key &&
                                                          item.relatedItemKey
                                                            .toLowerCase()
                                                            .includes(
                                                              selectedMetal.key.toLowerCase()
                                                            )
                                                      )
                                                      .flatMap((metal) =>
                                                        metal.relatedItemNames
                                                          .split(",")
                                                          .map((variation) => {
                                                            const trimmed =
                                                              variation.trim();
                                                            const upper =
                                                              trimmed.toUpperCase();

                                                            let shortName = null;
                                                            if (
                                                              upper.match(
                                                                /^(\d{1,2})K/
                                                              )
                                                            ) {
                                                              shortName =
                                                                upper.match(
                                                                  /^(\d{1,2})K/
                                                                )[1] + "K";
                                                            } else if (
                                                              upper.includes(
                                                                "PLATINUM"
                                                              )
                                                            ) {
                                                              shortName = "Pla";
                                                            } else if (
                                                              upper.includes(
                                                                "SILVER"
                                                              )
                                                            ) {
                                                              shortName = "Sil";
                                                            }

                                                            if (!shortName)
                                                              return null;

                                                            const cleanName =
                                                              trimmed
                                                                .toLowerCase()
                                                                .replace(
                                                                  / /g,
                                                                  "-"
                                                                )
                                                                .replace(
                                                                  /\(.*\)/,
                                                                  ""
                                                                );

                                                            return {
                                                              key: metal.relatedItemKey,
                                                              name: trimmed,
                                                              shortName,
                                                              imageUrl: `https://westendjewellery.com/assets/img/${cleanName}.png`,
                                                            };
                                                          })
                                                      )
                                                      .map((item, index) => (
                                                        <button
                                                          key={`${index}-${item.name}`}
                                                          className={`metal-option ${selectedMetal.name ===
                                                            item.name
                                                            ? "selected"
                                                            : ""
                                                            }`}
                                                          style={{
                                                            backgroundImage: `url(${item.imageUrl})`,
                                                            backgroundPosition:
                                                              "center",
                                                            backgroundSize:
                                                              "cover",
                                                          }}
                                                          title={item.name}
                                                          onClick={() => {
                                                            setSelectedMetal({
                                                              key: item.key,
                                                              name: item.name,
                                                            });
                                                          }}
                                                        >
                                                          {item.shortName}
                                                        </button>
                                                      ))}
                                                  </div>
                                                </div>
                                              </div>

                                              <hr />

                                              {apiSizes.length > 0 && (
                                                <div
                                                  className="ring-size-selection"
                                                  style={{}}
                                                >
                                                  <label
                                                    className="option-label text-center"
                                                    id="label-info-icon"
                                                  >
                                                    <button
                                                      className="label-info open-popup"
                                                      onClick={() =>
                                                        openPopup(1)
                                                      }
                                                    ></button>
                                                    Size
                                                  </label>

                                                  <select
                                                    className="ring_size"
                                                    value={selectedSize}
                                                    onChange={handleSizeChange}
                                                  >
                                                    {apiSizes.map((size) => (
                                                      <option
                                                        key={size.SizeId}
                                                        value={size.SizeValue}
                                                      >
                                                        {size.SizeValue}
                                                      </option>
                                                    ))}
                                                  </select>
                                                </div>
                                              )}

                                              <hr />
                                              <div className="stone-bandwidth">
                                                {stoneValues.length > 0 && (
                                                  <div
                                                    className="stone-type-container"
                                                    style={{ marginTop: "5px" }}
                                                  >
                                                    <label
                                                      className="option-label text-center"
                                                      id="label-info-icon"
                                                    >
                                                      <button
                                                        className="label-info open-popup"
                                                        onClick={() =>
                                                          openPopup(3)
                                                        }
                                                      ></button>
                                                      Stone Type
                                                    </label>
                                                    <div
                                                      className="stone-type-options"
                                                      style={{
                                                        justifyContent:
                                                          "start",
                                                      }}
                                                    >
                                                      {selectedMetal.name ===
                                                        "Silver(925)" ? (
                                                        <button
                                                          key={"CZ"}
                                                          className="stone-type-option active"
                                                          data-value="CZ"
                                                          onClick={() => {
  const defaultSize =
    apiSizes.find((s) => s.IsSelected)?.SizeValue ||
    apiSizes[0]?.SizeValue ||
    "N";

  setSelectedSize(defaultSize);
  setApiMetalWeight(0);

  setSelectedStone("CZ");
}}
                                                        >
                                                          CZ
                                                        </button>
                                                      ) : (
                                                        stoneValues.map(
                                                          (stone) => (
                                                            <button
                                                              key={stone}
                                                              className={`stone-type-option ${stone ===
                                                                selectedStone
                                                                ? "active"
                                                                : ""
                                                                }`}
                                                              data-value={stone}
                                                              onClick={() => {
  const defaultSize =
    apiSizes.find((s) => s.IsSelected)?.SizeValue ||
    apiSizes[0]?.SizeValue ||
    "N";

  setSelectedSize(defaultSize);
  setApiMetalWeight(0);

  // FIX: don't call handleGettheCaratSelected() here directly — the
  // useEffect below (dependent on [id, selectedStone, selectedShape])
  // already fires it as soon as setSelectedStone() below updates state.
  // Calling it in BOTH places fired two parallel GetDaimondwithcrt
  // requests for the same click; whichever response landed second would
  // silently overwrite the first, which is why the "selected" highlight
  // sometimes needed 2-3 clicks to actually stick (price looked fine
  // because that specific field happened to settle from whichever
  // response won the race).
  setSelectedStone(stone);
}}
                                                            >
                                                              {stone}
                                                            </button>
                                                          )
                                                        )
                                                      )}
                                                    </div>
                                                  </div>
                                                )}

                                                {checkboxes.some(
                                                  (checkbox) =>
                                                    checkbox.tableName ===
                                                    "Band"
                                                ) && (
                                                    <div className="stone-type-container">
                                                      <label className="stone-type-label text-center">
                                                        Band Width
                                                      </label>
                                                      <div
                                                        className="stone-type-options"
                                                        style={{
                                                          justifyContent:
                                                            "start",
                                                        }}
                                                      >
                                                        {checkboxes
                                                          .filter(
                                                            (checkbox) =>
                                                              checkbox.tableName ===
                                                              "Band"
                                                          )
                                                          .flatMap((checkbox) =>
                                                            checkbox.values.split(
                                                              ","
                                                            )
                                                          )
                                                          .map((band, index) => (
                                                            <button
                                                              key={band}
                                                              className={`bandwidth-stone-type-option ${selectedBandWidth ===
                                                                band.trim()
                                                                ? "active"
                                                                : ""
                                                                }`}
                                                              data-value={band}
                                                              onClick={() => {
                                                                setSelectedBandWidth(
                                                                  band.trim()
                                                                );
                                                                handleSelected(
                                                                  product.id,
                                                                  band.trim(),
                                                                  "band"
                                                                );
                                                              }}

                                                            >
                                                              {band}
                                                            </button>
                                                          ))}
                                                      </div>
                                                    </div>
                                                  )}
                                              </div>
                                              <hr />

                                              <div className="stone-clarity">
                                                {allClarities.length > 0 && (
                                                  <div className="stone-type-container" id="color-container">
                                                    <label className="option-label" id="label-info-icon">
                                                      <button
                                                        className="label-info open-popup"
                                                        onClick={() => openPopup(4)}
                                                      ></button>
                                                      Clarity
                                                    </label>

                                                    <div
                                                      className="stone-type-options"
                                                      style={{ justifyContent: "start" }}
                                                    >
                                                      {productcaratData
                                                        .filter(item => item.DiamondName === selectedStone)
                                                        .slice(0, 1)
                                                        .map(item => (
                                                          <button
                                                            key={item.ClarityName}
                                                            className={`stone-type-option active`}
                                                            onClick={() => {
                                                              handleButtonClick("Clarity", item.ClarityName)
                                                            }}

                                                          >

                                                            {item.ClarityName}
                                                          </button>
                                                        ))
                                                      }
                                                    </div>
                                                  </div>
                                                )}
                                              </div>

                                              <hr />
                                              <div className="color-certificate">
                                                {allColours.length > 0 && selectedStone && (
                                                  <div className="stone-type-container" id="color-container">
                                                    <label className="option-label" id="label-info-icon">
                                                      <button
                                                        className="label-info open-popup"
                                                        onClick={() => openPopup(5)}
                                                      ></button>
                                                      Colour
                                                    </label>
                                                    <div
                                                      className="stone-type-options"
                                                      style={{ justifyContent: "start" }}
                                                    >
                                                      {selectedStone === "Colour Stone" ? (

                                                        ProductCaratCodeData && ProductCaratCodeData.length > 0 ? (
                                                          ProductCaratCodeData

                                                            .filter(item => item.Diamondtype === selectedStone)

                                                            .flatMap(item =>
                                                              item.ColourName
                                                                ? item.ColourName.split(",").map(c => ({
                                                                  color: c.trim(),
                                                                  item: item,
                                                                }))
                                                                : []
                                                            )

                                                            .filter(
                                                              (obj, index, self) =>
                                                                obj.color &&
                                                                obj.color.trim() !== "" &&
                                                                index ===
                                                                self.findIndex(
                                                                  (o) =>
                                                                    o.color.toLowerCase() === obj.color.toLowerCase()
                                                                )
                                                            )

                                                            .map(({ color, item }) => {
                                                              const imageName = color.toLowerCase().replace(/\s+/g, "");
                                                              const imageUrl = `${Web_Image_URL}colors/${encodeURIComponent(imageName)}.png`;

                                                              const isActive =
                                                                selectedValues.ProductCodes === item.ProductCode;

                                                              return (
                                                                <button
                                                                  key={`${color}-${item.ProductCode}`}
                                                                  className={`shape-option ${isActive ? "active" : ""}`}
                                                                  
                                                                  onClick={() => {
  const productCode = item.ProductCode;
  const carat = item.Carat;
  const colour = color;

  setSelectedValues((prev) => ({
    ...prev,
    Colour: colour,
    ProductCodes: productCode,
  }));

  if (carat) {
    setCaratForImg(carat);
    setSelectedCaratValue(getItemCaratValue(item)); // 🔑 remember this carat/size
  }

  // Reset size to default
  const defaultSize =
    apiSizes.find((s) => s.IsSelected)?.SizeValue ||
    apiSizes[0]?.SizeValue ||
    "N";

  setSelectedSize(defaultSize);

  // Reset weight
  setApiMetalWeight(0);

  handleSelectedCarate(
    id,
    selectedStone,
    selectedShape,
    selectedMetal?.name,
    productCode
  );

  // Reload price with default size
  fetchProductPrice(
    product.id,
    selectedMetal.name,
    defaultSize,
    selectedStone,
    selectedShape,
    productCode,
    0
  );
}}
                                                                  style={{
                                                                    border: isActive
                                                                      ? "2px solid #000"
                                                                      : "1px solid #ccc",
                                                                    padding: "5px",
                                                                    borderRadius: "6px",
                                                                    background: "transparent",
                                                                    cursor: "pointer",
                                                                    margin: "4px",
                                                                  }}
                                                                >
                                                                  <img

                                                                    src={imageUrl}
                                                                    alt={color}
                                                                    width={35}
                                                                    height={35}
                                                                    style={{
                                                                      objectFit: "cover",
                                                                      borderRadius: "4px",
                                                                      opacity: isActive ? 1 : 0.7,
                                                                    }}
                                                                    onError={(e) => {
                                                                      e.target.src = `${Web_Image_URL}colors/default.png`;
                                                                    }}
                                                                  />
                                                                </button>
                                                              );
                                                            })
                                                        ) : (
                                                          <p>No colour options found</p>
                                                        )
                                                      ) : (
                                                        // 🔥 ELSE → keep your original logic
                                                        productcaratData
                                                          .filter(item => item.DiamondName === selectedStone)

                                                          .flatMap(item => {
                                                            if (item.ColorName) {
                                                              return [
                                                                {
                                                                  color: item.ColorName,
                                                                  item: item,
                                                                },
                                                              ];
                                                            }
                                                            return [];
                                                          })

                                                          .filter(
                                                            (obj, index, self) =>
                                                              obj.color &&
                                                              obj.color.trim() !== "" &&
                                                              index ===
                                                              self.findIndex(
                                                                (o) =>
                                                                  o.color.toLowerCase() === obj.color.toLowerCase()
                                                              )
                                                          )

                                                          .map(({ color, item }) => {
                                                            const isActive = selectedValues.Colour === color;

                                                            return (
                                                              <button
                                                                key={color}
                                                                className={`shape-option ${isActive ? "active" : ""}`}
                                                                onClick={() => {
                                                                  setSelectedValues((prev) => ({
                                                                    ...prev,
                                                                    Colour: color,
                                                                    ProductCodes: item.ProductCode,
                                                                  }));
                                                                }}
                                                                style={{
                                                                  border: isActive
                                                                    ? "2px solid #000"
                                                                    : "1px solid #ccc",
                                                                  padding: "5px",
                                                                  borderRadius: "6px",
                                                                  background: "transparent",
                                                                  cursor: "pointer",
                                                                  margin: "4px",
                                                                }}
                                                              >
                                                                <span>{color}</span>
                                                              </button>
                                                            );
                                                          })
                                                      )}
                                                    </div>



                                                  </div>
                                                )}
                                              </div>





                                              {productcaratData.length > 0 &&
                                                selectedStone &&
                                                productcaratData.some(x => x.CertificateName && x.CertificateName.trim() !== "") && (
                                                  <><hr />
                                                    <div className="color-certificate">
                                                      <div className="stone-type-container" id="color-container">

                                                        <label className="option-label" id="label-info-icon">
                                                          Certificate
                                                        </label>

                                                        <div className="stone-type-options" style={{ justifyContent: "center" }}>
                                                          {productcaratData
                                                            .filter(item =>
                                                              item.DiamondName === selectedStone &&
                                                              item.CertificateName && item.CertificateName.trim() !== ""
                                                            )
                                                            .slice(0, 1)
                                                            .map(item => (
                                                              <button
                                                                key={item.CertificateName}
                                                                className="color-stone-type-option active"
                                                                data-value={item.CertificateName}
                                                                onClick={() =>
                                                                  handleButtonClick("Certificate", item.CertificateName)
                                                                }
                                                              >
                                                                {item.CertificateName}
                                                              </button>
                                                            ))
                                                          }
                                                        </div>

                                                      </div>
                                                    </div>
                                                  </>
                                                )}



                                              <hr />
                                              <div className="shapes">
                                                <div className="shape-selection">
                                                  <label className="option-label" id="label-info-icon">
                                                    Cut
                                                  </label>
                                                  <div className="shape-options">
                                                    {checkboxes
                                                      .filter(
                                                        (checkbox) =>
                                                          checkbox.tableName ===
                                                          "Shape"
                                                      )
                                                      .map(
                                                        (checkbox, index) => {
                                                          const valuesArray =
                                                            checkbox.values.split(
                                                              ","
                                                            );
                                                          return valuesArray.map(
                                                            (value, idx) => (
                                                              <button
                                                                key={`${index}-${idx}`}
                                                                className={`shape-option ${selectedShape ===
                                                                  value
                                                                  ? "selected"
                                                                  : ""
                                                                  }`}
                                                                data-shape={value.toLowerCase()}
                                                                style={{
                                                                  backgroundImage: `url(https://westendjewellery.com/assets/img/${value
                                                                    .trim()
                                                                    .replace(
                                                                      /\s+/g,
                                                                      ""
                                                                    )
                                                                    .toLowerCase()}.png)`,
                                                                  backgroundPosition:
                                                                    "center",
                                                                  backgroundSize:
                                                                    "contain",
                                                                }}
                                                                title={value}
                                                                onClick={() => {
                                                                  setSelectedShape(
                                                                    value
                                                                  ); // Update the active shape
                                                                  handleSelected(
                                                                    product.id,
                                                                    value,
                                                                    "shape"
                                                                  );
                                                                }}

                                                              ></button>
                                                            )
                                                          );
                                                        }
                                                      )}
                                                  </div>
                                                </div>
                                              </div>

                                              <hr />

                                              <div className="shapes">
                                                <div className="shape-selection">
                                                  <label className="option-label" id="label-info-icon">
                                                    {product.stoneTag}

                                                  </label>
                                                  <div className="stone-type-options">


                                                    {ProductCaratCodeData &&
                                                      ProductCaratCodeData.length >
                                                      0 ? (
                                                      uniqueItems
                                                        .slice()
                                                        .sort((a, b) => a.Carat - b.Carat)
                                                        .map((item, index) => {
                                                          const stockEntries = productStockData.filter(
                                                            (stock) => stock.ProductCode === item.ProductCode
                                                          );

                                                          const inStock = stockEntries.some(
                                                            (stock) => stock.Quantity > 0
                                                          );

                                                          return (
                                                            <div
                                                              key={index}
                                                              style={{
                                                                display: "inline-flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                margin: "5px",
                                                              }}
                                                            >
                                                              <button
                                                                type="button"
                                                                style={{ padding: "8px 14px" }}
                                                                className={`unique-carat-box ${selectedValues.ProductCodes === item.ProductCode
                                                                  ? "selected"
                                                                  : ""
                                                                  }`}
                                                            onClick={() => {
  setSelectedValues((prev) => ({
    ...prev,
    ProductCodes: item.ProductCode,
  }));

  setCaratForImg(item.Carat);
  setSelectedCaratValue(getItemCaratValue(item)); // 🔑 remember this carat/size

  // Reset size to default
  const defaultSize =
    apiSizes.find((s) => s.IsSelected)?.SizeValue ||
    apiSizes[0]?.SizeValue ||
    "N";

  setSelectedSize(defaultSize);

  // Reset weight
  setApiMetalWeight(0);

  handleSelectedCarate(
    id,
    selectedStone,
    selectedShape,
    selectedMetal.name,
    item.ProductCode
  );

  // Recalculate price
  fetchProductPrice(
    product.id,
    selectedMetal.name,
    defaultSize,
    selectedStone,
    selectedShape,
    item.ProductCode,
    0
  );
}}
                                                              >
                                                                {
                                                                  product?.stoneTag?.includes("Colour Stone MM Size")
                                                                    ? item.sizeMM
                                                                    : formatCarat(
                                                                      product?.stoneTag === "Center Stone"
                                                                        ? item.DefaultCarat
                                                                        : item.Carat
                                                                    )
                                                                }
                                                              </button>

                                                              {/* <div
                                                                style={{
                                                                  fontSize: "12px",
                                                                  marginTop: "3px",
                                                                  color: inStock ? "rgb(2 137 84)" : "",
                                                                }}
                                                              >
                                                                {inStock ? "In Stock" : ""}
                                                              </div> */}
                                                            </div>
                                                          );
                                                        })



                                                    ) : (
                                                      <p>
                                                        No carat options found
                                                      </p>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>

                                              <hr />

                                              <div>
                                                {loading ? (
                                                  <p>Loading...</p>
                                                ) : productcaratData.length >
                                                  0 ? (
                                                  <div
                                                    className="custom-product-options2"
                                                    style={{ display: "block" }}
                                                  >
                                                    <label>Diamond Details</label>
                                                    <hr />
                                                    <div className="table-container">
                                                      <table className="custom-table">
                                                        <thead>
                                                          <tr>
                                                            <th>Shape</th>
                                                            <th>Size (MM)</th>
                                                            <th>Quantity</th>
                                                            <th>Carat</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {productcaratData
                                                            // .filter(
                                                            //   (item) =>
                                                            //     item.DiamondName ===
                                                            //     selectedStone
                                                            // ) // ✅ Only match selected stone
                                                            .map((item) => (
                                                              <tr
                                                                key={
                                                                  item.ShapewithcrtId
                                                                }
                                                              >
                                                                <td>
                                                                  {item.ShapeName ||
                                                                    ""}
                                                                </td>
                                                                <td>
                                                                  {item.StoneMM ||
                                                                    ""}
                                                                </td>
                                                                <td>
                                                                  {item.StoneQty ||
                                                                    ""}
                                                                </td>
                                                                <td>
                                                                  {item.StoneCrt.toFixed(
                                                                    2
                                                                  ) || ""}
                                                                </td>
                                                              </tr>
                                                            ))}
                                                        </tbody>
                                                      </table>

                                                    </div>
                                                  </div>
                                                ) : null}
                                              </div>
                                              <hr />

                                              <div className="carat">
                                                <div className="carat-selection">

                                                  <label className="option-label" id="netwait">
                                                    Total Carat  <b>{finalCaratRounded}</b>


                                                  </label>

                                                </div>
                                              </div>


                                              <hr />
                                              {checkboxes.some(
                                                (checkbox) =>
                                                  checkbox.tableName ===
                                                  "Cutgrade"
                                              ) && (
                                                  <>
                                                    <div
                                                      className="stone-type-container"
                                                      id="excellent-options"
                                                    >
                                                      <label
                                                        className="stone-type-label text-center"
                                                        id="cut-label"
                                                      >
                                                        Cut Grade
                                                      </label>
                                                      <div
                                                        className="stone-type-options"
                                                        style={{
                                                          justifyContent:
                                                            "center",
                                                        }}
                                                      >
                                                        {checkboxes
                                                          .filter(
                                                            (checkbox) =>
                                                              checkbox.tableName ===
                                                              "Cutgrade"
                                                          )
                                                          .flatMap(
                                                            (checkbox, index) =>
                                                              checkbox.values
                                                                .split(",")
                                                                .map(
                                                                  (
                                                                    value,
                                                                    idx
                                                                  ) => (
                                                                    <button
                                                                      key={`${index}-${idx}`}
                                                                      className={`cut-stone-type-option ${selectedValues.Cutgrade ===
                                                                        value
                                                                        ? "active"
                                                                        : ""
                                                                        }`}
                                                                      data-value={
                                                                        value
                                                                      }
                                                                      onClick={() =>
                                                                        handleButtonClick(
                                                                          "Cutgrade",
                                                                          value
                                                                        )
                                                                      }
                                                                    >
                                                                      {value}
                                                                    </button>
                                                                  )
                                                                )
                                                          )}
                                                      </div>
                                                    </div>
                                                    <hr />
                                                  </>
                                                )}

                                              {checkboxes.some(
                                                (checkbox) =>
                                                  checkbox.tableName ===
                                                  "Polish"
                                              ) && (
                                                  <>
                                                    <div
                                                      className="stone-type-container"
                                                      id="excellent-options"
                                                    >
                                                      <label
                                                        className="stone-type-label text-center"
                                                        id="cut-label"
                                                      >
                                                        Polish
                                                      </label>
                                                      <div
                                                        className="stone-type-options"
                                                        style={{
                                                          justifyContent:
                                                            "center",
                                                        }}
                                                      >
                                                        {checkboxes
                                                          .filter(
                                                            (checkbox) =>
                                                              checkbox.tableName ===
                                                              "Polish"
                                                          )
                                                          .flatMap(
                                                            (checkbox, index) =>
                                                              checkbox.values
                                                                .split(",")
                                                                .map(
                                                                  (
                                                                    value,
                                                                    idx
                                                                  ) => (
                                                                    <button
                                                                      key={`${index}-${idx}`}
                                                                      className={`polish-stone-type-option ${selectedValues.Polish ===
                                                                        value
                                                                        ? "active"
                                                                        : ""
                                                                        }`}
                                                                      data-value={
                                                                        value
                                                                      }
                                                                      onClick={() =>
                                                                        handleButtonClick(
                                                                          "Polish",
                                                                          value
                                                                        )
                                                                      }
                                                                    >
                                                                      {value}
                                                                    </button>
                                                                  )
                                                                )
                                                          )}
                                                      </div>
                                                    </div>
                                                    <hr />
                                                  </>
                                                )}

                                              {checkboxes.some(
                                                (checkbox) =>
                                                  checkbox.tableName ===
                                                  "Symmetry"
                                              ) && (
                                                  <>
                                                    <div
                                                      className="stone-type-container"
                                                      id="excellent-options"
                                                    >
                                                      <label
                                                        className="stone-type-label text-center"
                                                        id="cut-label"
                                                      >
                                                        Symmetry
                                                      </label>
                                                      <div
                                                        className="stone-type-options"
                                                        style={{
                                                          justifyContent:
                                                            "center",
                                                        }}
                                                      >
                                                        {checkboxes
                                                          .filter(
                                                            (checkbox) =>
                                                              checkbox.tableName ===
                                                              "Symmetry"
                                                          )
                                                          .flatMap(
                                                            (checkbox, index) =>
                                                              checkbox.values
                                                                .split(",")
                                                                .map(
                                                                  (
                                                                    value,
                                                                    idx
                                                                  ) => (
                                                                    <button
                                                                      key={`${index}-${idx}`}
                                                                      className={`symmetry-stone-type-option ${selectedValues.Symmetry ===
                                                                        value
                                                                        ? "active"
                                                                        : ""
                                                                        }`}
                                                                      data-value={
                                                                        value
                                                                      }
                                                                      onClick={() =>
                                                                        handleButtonClick(
                                                                          "Symmetry",
                                                                          value
                                                                        )
                                                                      }
                                                                    >
                                                                      {value}
                                                                    </button>
                                                                  )
                                                                )
                                                          )}
                                                      </div>
                                                    </div>
                                                    <hr />
                                                  </>
                                                )}

                                              {checkboxes.some(
                                                (checkbox) =>
                                                  checkbox.tableName === "Fluo"
                                              ) && (
                                                  <div
                                                    className="stone-type-container"
                                                    id="excellent-options"
                                                  >
                                                    <label
                                                      className="stone-type-label text-center"
                                                      id="cut-label"
                                                    >
                                                      Fluo
                                                    </label>
                                                    <div
                                                      className="stone-type-options"
                                                      style={{
                                                        justifyContent: "center",
                                                      }}
                                                    >
                                                      {checkboxes
                                                        .filter(
                                                          (checkbox) =>
                                                            checkbox.tableName ===
                                                            "Fluo"
                                                        )
                                                        .flatMap(
                                                          (checkbox, index) =>
                                                            checkbox.values
                                                              .split(",")
                                                              .map(
                                                                (value, idx) => (
                                                                  <button
                                                                    key={`${index}-${idx}`}
                                                                    className={`fluo-stone-type-option ${selectedValues.Fluo ===
                                                                      value
                                                                      ? "active"
                                                                      : ""
                                                                      }`}
                                                                    data-value={
                                                                      value
                                                                    }
                                                                    onClick={() =>
                                                                      handleButtonClick(
                                                                        "Fluo",
                                                                        value
                                                                      )
                                                                    }
                                                                  >
                                                                    {value}
                                                                  </button>
                                                                )
                                                              )
                                                        )}
                                                    </div>
                                                  </div>
                                                )}
                                            </div>
                                          </div>

                                          {/* <div className="description">
                                                                                        <p dangerouslySetInnerHTML={{ __html: limitWords(product.productDescription, 50) }} />
                                                                                    </div> */}

                                          {product.engrave && (
                                            <div className="engrave">
                                              <label
                                                htmlFor="engrave"
                                                className="stone-type-label"
                                                style={{ marginBottom: 0 }}
                                              >
                                                Engrave{" "}
                                                <input
                                                  maxLength={25}
                                                  type="text"
                                                  name="engrave"
                                                  id="engrave"
                                                  onInput={(e) => {
                                                    e.target.value =
                                                      e.target.value.replace(
                                                        /[^A-Za-z ]/g,
                                                        ""
                                                      );
                                                  }}
                                                />{" "}
                                                (25 letters)
                                              </label>
                                            </div>
                                          )}

                                          <div className="variations">
                                            <table cellSpacing="0">
                                              <tbody>
                                                <tr></tr>
                                              </tbody>
                                            </table>
                                          </div>
                                          <div className="buttons">
                                            <div
                                              className="btn-quick-buy"
                                              data-title="Wishlist"
                                            >
                                              {/* <a className="product-btn" href="/cart">Check Out</a> */}
                                              <button
                                                className="product-btn"
                                                onClick={() =>
                                                  CheckOut(product)
                                                }
                                              >
                                                Check Out
                                              </button>
                                            </div>
                                            <div
                                              className="btn-quick-buy"
                                              data-title="Wishlist"
                                            >
                                              <button
                                                className="product-btn"
                                                onClick={() =>
                                                  addToCart(product)
                                                }
                                              >
                                                Add to Cart
                                              </button>
                                            </div>



                                          </div>
                                          <div className="btn-quick-buy">
                                            <button
                                              className="product-btn"
                                              onClick={() =>
                                                setShowPopup(true)
                                              }
                                            >
                                              Request For Any Modification{" "}
                                            </button>
                                          </div>
                                          <div className="unique-delivery-info">
                                            <p>
                                              <img
                                                src="./assets/img/returns-icon.svg"
                                                alt=""
                                              />{" "}
                                              Shipping and Return Policies
                                              <i
                                                className="fa fa-info-circle"
                                                aria-hidden="true"
                                              ></i>
                                            </p>
                                          </div>
                                          <div className="product-details">
                                            <h3 className="details-heading">
                                              Product Details
                                            </h3>
                                            <div className="details-section">
                                              <div className="detail-row">
                                                <span className="detail-label">
                                                  Design Number:
                                                </span>
                                                <span className="detail-value">
                                                  {product.productCode}
                                                </span>
                                              </div>

                                              <div className="detail-row">
                                                <span className="detail-label">
                                                  Product Code:
                                                </span>
                                                <span className="detail-value">
                                                  {selectedValues.ProductCodes}
                                                </span>
                                              </div>

                                              {/* <div className="detail-row">
                                                                                                <span className="detail-label">Certificate:</span>
                                                                                                <span className="detail-value">{selected}</span>
                                                                                            </div> */}
                                              <div className="detail-row">
                                                <span className="detail-label">
                                                  Metal:
                                                </span>
                                                <span className="detail-value">
                                                  {selectedMetal.name}
                                                </span>
                                              </div>
                                            </div>

                                            <div className="details-section">
                                              <div className="detail-row">
                                                <span className="detail-label">
                                                  Stone Type:
                                                </span>
                                                <span className="detail-value">
                                                  {selectedStone}
                                                </span>
                                              </div>
                                              <div className="detail-row">
                                                <span className="detail-label">
                                                  Shape:
                                                </span>
                                                <span className="detail-value">
                                                  {selectedShape}
                                                </span>
                                              </div>
                                              <div className="detail-row">
                                                <span className="detail-label">
                                                  Colour:
                                                </span>
                                                <span className="detail-value">
                                                  {selectedValues.Colour}
                                                </span>
                                              </div>
                                              <div className="detail-row">
                                                <span className="detail-label">
                                                  Clarity:
                                                </span>
                                                <span className="detail-value">
                                                  {selectedValues.Clarity}
                                                </span>
                                              </div>
                                              <div className="detail-row">
                                                <span className="detail-label">
                                                  Setting:
                                                </span>
                                                <span className="detail-value">
                                                  Prong
                                                </span>
                                              </div>
                                              {/* <div className="detail-row">
                                                <span className="detail-label">
                                                  Metal Weight:
                                                </span>
                                                <span className="detail-value">
                                                  {apiMetalWeight}
                                                </span>
                                              </div> */}
                                              {/* <div className="detail-row">
                                                                                                <span className="detail-label">Total Weight:</span>
                                                                                                <span className="detail-value">
                                                                                                    Approx. 1.2860 ct. wt. (0.600ct. x 1, 0.006ct. x 1, 0.500ct. x 1, 0.012ct. x 15)
                                                                                                </span>
                                                                                            </div> */}
                                            </div>
                                          </div>

                                          <div className="product-meta">
                                            {/* <span className="sku-wrapper">
                                              SKU:{" "}
                                              <span className="sku">
                                                {selectedValues.ProductCodes}
                                              </span>
                                            </span>
                                            <span className="posted-in">
                                              Category:
                                              <a href="/products" rel="tag">
                                                {product.categoryName}
                                              </a>
                                            </span> */}
                                            {/* <span className="tagged-as">
                                                                                            Tags:{" "}
                                                                                            <a href="/products" rel="tag">
                                                                                                Hot Trend
                                                                                            </a>
                                                                                        </span> */}
                                          </div>

                                          {/* <div className="social-share">
                                                                                        <a href="#" title="Facebook" className="share-facebook" target="_blank" rel="noopener noreferrer">
                                                                                            <i className="fa fa-facebook"></i>Facebook
                                                                                        </a>
                                                                                        <a href="#" title="Twitter" className="share-twitter">
                                                                                            <i className="fa fa-twitter"></i>Twitter
                                                                                        </a>
                                                                                        <a href="#" title="Pinterest" className="share-pinterest">
                                                                                            <i className="fa fa-pinterest"></i>Pinterest
                                                                                        </a>
                                                                                    </div> */}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          {isImagePopupOpen && (
            <div
              className="image-popup-overlay"
              onClick={() => setIsImagePopupOpen(false)}
            >
              <div
                className="image-popup-content"
                onClick={(e) => e.stopPropagation()}
              >
                {/* Close Button */}
                <button
                  className="popup-close-btn"
                  onClick={() => setIsImagePopupOpen(false)}
                >
                  ✕
                </button>


                <Slider {...popupSliderSettings}>
                  {imagesData.map((src, index) => (
                    <div key={index} className="popup-slide">
                      <img src={src} className="popup-image" />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          )}
          <Footer />
        </div>
        {/* Back Top Button */}
        <div className="back-top button-show">
          <i className="arrow_carrot-up"></i>
        </div>



        {showPopup && (
          <div className="modal fade show">
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title"></h5>

                  <button
                    className="btn-close"
                    onClick={() => setShowPopup(false)}
                  >
                    X{" "}
                  </button>
                </div>

                <div className="modal-body">
                  <RequestforpriceForm
                    productCode={product.productCode}
                    designCode={selectedValues.ProductCodes}
                    productId={product.id}
                    productImg={imagesData[activeIndex]}
                    onClose={() => setShowPopup(false)}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <RingPopup
        isOpen={isPopupOpen}
        contentId={contentId}
        onClose={closePopup}
      />
    </div>
  );
};

export default InsideProduct;